/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListinoPulciniDettaglioUpdateDTO
 */
export interface ListinoPulciniDettaglioUpdateDTO {
    /**
     * 
     * @type {number}
     * @memberof ListinoPulciniDettaglioUpdateDTO
     */
    idTipoAnimale?: number;
    /**
     * 
     * @type {Date}
     * @memberof ListinoPulciniDettaglioUpdateDTO
     */
    inizioValidita?: Date;
    /**
     * 
     * @type {number}
     * @memberof ListinoPulciniDettaglioUpdateDTO
     */
    valore?: number;
}

/**
 * Check if a given object implements the ListinoPulciniDettaglioUpdateDTO interface.
 */
export function instanceOfListinoPulciniDettaglioUpdateDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ListinoPulciniDettaglioUpdateDTOFromJSON(json: any): ListinoPulciniDettaglioUpdateDTO {
    return ListinoPulciniDettaglioUpdateDTOFromJSONTyped(json, false);
}

export function ListinoPulciniDettaglioUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListinoPulciniDettaglioUpdateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idTipoAnimale': !exists(json, 'idTipoAnimale') ? undefined : json['idTipoAnimale'],
        'inizioValidita': !exists(json, 'inizioValidita') ? undefined : (new Date(json['inizioValidita'])),
        'valore': !exists(json, 'valore') ? undefined : json['valore'],
    };
}

export function ListinoPulciniDettaglioUpdateDTOToJSON(value?: ListinoPulciniDettaglioUpdateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idTipoAnimale': value.idTipoAnimale,
        'inizioValidita': value.inizioValidita === undefined ? undefined : (value.inizioValidita.toISOString()),
        'valore': value.valore,
    };
}

